"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoredEvidence = void 0;
const react_1 = __importStar(require("react"));
const dated_evidence_1 = require("./../dated-evidence/dated-evidence");
const authored_fields_1 = require("./../authored-evidence/authored-fields");
const authored_columns_1 = require("./../authored-evidence/authored-columns");
function useAuthoredEvidence(options) {
    var _a, _b;
    react_1.useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            console.warn('useAuthoredEvidence is deprecated. Use @eas/common-web/AuthoredEvidence instead.');
        }
    }, []);
    const columns = authored_columns_1.useColumns({
        columns: (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.columns,
    });
    const GeneralFieldsComponent = react_1.useMemo(() => function Fields() {
        var _a;
        return (react_1.default.createElement(authored_fields_1.AuthoredFields, { FieldsComponent: (_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.GeneralFieldsComponent }));
    }, [(_b = options.detailProps) === null || _b === void 0 ? void 0 : _b.GeneralFieldsComponent]);
    return dated_evidence_1.useDatedEvidence({
        ...options,
        tableProps: {
            ...options.tableProps,
            columns,
        },
        detailProps: {
            GeneralFieldsComponent,
            ...options.detailProps,
        },
    });
}
exports.useAuthoredEvidence = useAuthoredEvidence;
//# sourceMappingURL=authored-evidence.js.map